
export default function (value) {
  if (typeof value !== 'number') {
    return value
  }
  const val = parseFloat(value).toFixed(2)
  return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
